import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLCacheClient } from '../../graphQLClients';

import { DeleteItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';
import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface DeleteCacheItemProps<DeleteCacheItemInput> {
  action: string;
  query: DeleteItemGqlQuery;
  queryInput: DeleteCacheItemInput;
}

const successQueryStatuses = ['deleted', 'success'];

export function deleteCacheItem<DeleteCacheItemInput, DeleteCacheItemResponse>({
  action,
  query,
  queryInput
}: DeleteCacheItemProps<DeleteCacheItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'deleteCacheItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLCacheClient.addQueryParams(name, requestId);

  return new Promise<DeleteCacheItemResponse>((resolve, reject) => {
    return graphQLCacheClient
      .request<DeleteCacheItemResponse, DeleteCacheItemInput>(
        query,
        queryInput,
        {
          requestId
        }
      )
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
